module.exports = __webpack_public_path__ + "static/media/banner1.182fd1c6.jpg";